export const removeTrailingDots = (text: string): string =>
  text.lastIndexOf('…') === text.length - 1 ? text.replace('…', '') : text;
